import { useCallback } from 'react';

import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { useCloseActivity } from '@queries';
import { UserSettings } from '@screens';
import { currentActivityAtom, isCurrentActivityAtom } from '@store';

import { LINKS } from '../utils/routes';

export const UserSettingsScreen = () => {
    const navigate = useNavigate();
    const { mutateAsync: closeCurrentActivity } = useCloseActivity();
    const currentActivity = useAtomValue(currentActivityAtom);
    const isCurrentActivity = useAtomValue(isCurrentActivityAtom);

    const startNewActivity = useCallback(async () => {
        if (!currentActivity || !isCurrentActivity) {
            throw Error('Unreachable state');
        }
        await closeCurrentActivity(currentActivity?.id);
        navigate(LINKS.createActivity(currentActivity.club?.id));
        return currentActivity.id;
    }, [closeCurrentActivity, currentActivity, isCurrentActivity, navigate]);

    return <UserSettings onCreateNewActivity={isCurrentActivity ? startNewActivity : undefined} />;
};
